import { Duration } from "luxon";
import { OneOnOnesQueryQuery } from "../graphql/__generated__/OneOnOnes.generated";

export const parseOneOnOneStatsGQL = (data: OneOnOnesQueryQuery | undefined) => {
  let oneOnOneAvgWeekly: Duration = Duration.fromObject({ hours: 0 });

  const dashboard = data?.viewer?.user?.orgs?.edges?.[0]?.node?.flexibleMeetingsDashboard;

  if (dashboard) {
    oneOnOneAvgWeekly = Duration.fromISO(dashboard.myOneOnOneAverage);
  }

  return { oneOnOneAvgWeekly };
};

export default parseOneOnOneStatsGQL;
